// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"0722f7ae","453":"d959caf7"}[chunkId] + ".chunk.js";
};